/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

import px2rem from '@kufox/mui/utils/px2rem';
import { useResponsive, useTheme } from '@kufox/mui/hooks';
import { Box, Row, Col } from '@kufox/mui';
import { styled } from '@kufox/mui/emotion';

const BackgroundPos = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  display: flex;
`;

const StyledBackgroundImg = styled.img`
  flex: 1 1 50%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
`;

const genVoidFunc = () => () => null;

const LayoutSlots = genVoidFunc();
const Logo = genVoidFunc();
const BackgroundStyle = genVoidFunc();
const Text = genVoidFunc();
const RightHeader = genVoidFunc();
const LeftFooter = genVoidFunc();
const RightFooter = genVoidFunc();
const LeftFull = genVoidFunc();
const BackgroundImg = genVoidFunc();

LayoutSlots.Logo = Logo;
LayoutSlots.BackgroundStyle = BackgroundStyle;
LayoutSlots.BackgroundImg = BackgroundImg;
LayoutSlots.Text = Text;
LayoutSlots.RightHeader = RightHeader;
LayoutSlots.LeftFooter = LeftFooter;
LayoutSlots.RightFooter = RightFooter;
LayoutSlots.LeftFull = LeftFull;

const Layout = (props) => {
  const { slots, children } = props;
  const logo = slots.find((slot) => slot.type === Logo);
  const backgroundStyle = slots.find((slot) => slot.type === BackgroundStyle);
  const text = slots.find((slot) => slot.type === Text);
  const rightHeader = slots.find((slot) => slot.type === RightHeader);
  const leftFooter = slots.find((slot) => slot.type === LeftFooter);
  const rightFooter = slots.find((slot) => slot.type === RightFooter);
  const leftFull = slots.find((slot) => slot.type === LeftFull);

  const backgroundImg = slots.find((slot) => slot.type === BackgroundImg);
  const rv = useResponsive();

  const theme = useTheme();

  return (
    <Row style={{ minHeight: '810px', height: '100vh' }}>
      <Col
        style={{
          ...(backgroundStyle && backgroundStyle.props.children),
          position: 'relative',
          height: '100%',
          ...(rv.md
            ? {
                display: 'block',
              }
            : {
                display: 'none',
              }),
        }}
        sm={0}
        md={10}
        lg={10}
      >
        {leftFull ? (
          leftFull.props.children
        ) : (
          <Box
            position="relative"
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <Box position="absolute" left={0} top={0} width="100%">
              <Box width="100%" height={80} paddingLeft="60px" display="flex" alignItems="center">
                {logo && logo.props.children}
              </Box>
            </Box>
            {text && text.props.children}
            <Box position="absolute" bottom={0} let={0} width="100%">
              {leftFooter && leftFooter.props.children}
            </Box>
          </Box>
        )}
        {/* background-img 改直接 img 显示的形式，方便做自适应 */}
        {backgroundImg && backgroundImg.props.src && (
          <BackgroundPos {...backgroundImg.props}>
            <StyledBackgroundImg src={backgroundImg.props.src} />
          </BackgroundPos>
        )}
      </Col>
      <Col
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          background: theme.colors.backgroundMajor,
        }}
        sm={24}
        md={14}
        lg={14}
      >
        <Box
          position="relative"
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%"
          width="100%"
          paddingLeft={{ sm: px2rem(12), md: px2rem(24), lg: px2rem(24) }}
          paddingRight={{ sm: px2rem(12), md: px2rem(24), lg: px2rem(24) }}
        >
          <Box position="absolute" top={0} right={0} width="100%">
            <Box
              width="100%"
              height="80px"
              paddingRight="60px"
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
            >
              {rightHeader && rightHeader.props.children}
            </Box>
          </Box>
          {children}
          <Box position="absolute" bottom={0} right={0} width="100%">
            {rightFooter && rightFooter.props.children}
          </Box>
        </Box>
      </Col>
    </Row>
  );
};

Layout.withLayout = (WrappedComponent) => {
  const ComponentWithLayout = (props) => {
    const { children } = props;
    const slotsWrap = React.Children.toArray(children).find((child) => child.type === LayoutSlots);

    const slots = slotsWrap ? React.Children.toArray(slotsWrap.props.children) : [];

    return (
      <Layout slots={slots}>
        <WrappedComponent {...props} />
      </Layout>
    );
  };

  ComponentWithLayout.LayoutSlots = LayoutSlots;

  return ComponentWithLayout;
};

export default Layout;
